import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { useDispatch } from "react-redux";
import Select from "react-select";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import { FaSpinner } from "react-icons/fa";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import * as Yup from "yup";
import { toast } from "react-toastify";
import moment from "moment";

const MyTaskEdit = () => {
  const initialFormData = {
    ProjectID: null,
    StartDate: "",
    EndDate: "",
    Name: "",
    Details: "",
    CategoryID: null,
    Status: 1083,
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});
  const [newStatusOptions, setNewStatusOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);

  useEffect(() => {
    dispatch(updateNavbarHeading("Edit Task"));
    fetchGetData();
  }, [dispatch]);

  useEffect(() => {
    if (id) {
      fetchShowApiData(id);
    }
  }, [id]);
  const fetchGetData = async () => {
    try {
      setLoading(true);
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/task/task/addPageDetails`
      );

      if (response?.status === 200) {
        const cleanedData = response?.data?.data;

        const projectOpt = cleanedData?.projectList?.map((o) => ({
          value: o.value,
          label: o.text,
        }));
        setProjectOptions(projectOpt);
        const newStatusOpt = cleanedData?.status?.map((o) => ({
          value: o.value,
          label: o.text,
        }));
        setNewStatusOptions(newStatusOpt);
        // setFormData((prevData) => ({
        //   ...prevData,
        //   Status: newStatusOpt[0].value,
        // }));

        const catOpt = cleanedData?.taskCategory?.map((o) => ({
          value: o.value,
          label: o.text,
        }));
        setCategoryOptions(catOpt);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to load form options");
    } finally {
      setLoading(false);
    }
  };
  const fetchShowApiData = async (id) => {
    try {
      setLoading(true);
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/task/my-task/${id}`
      );

      if (response?.status === 200) {
        const cleanedData = response?.data?.data;
        console.log("cleanedData",cleanedData);
        
        const formEditData = {
            ProjectID: cleanedData?.ProjectID,
            StartDate:cleanedData?.StartDate,
            EndDate: cleanedData?.EndDate,
            Name: cleanedData?.Name,
            Details:cleanedData?.Details,
            CategoryID: cleanedData?.TaskCategory_219,
            Status: cleanedData?.Status||1083,
        }
        setFormData(formEditData)
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to load form options");
    } finally {
      setLoading(false);
    }
  };

  const validationSchema = Yup.object().shape({
    ProjectID: Yup.number()
      .typeError("Project is required")
      .required("Project is required"),
    Name: Yup.string().required("Task name is required"),
    StartDate: Yup.string().nullable(),
    EndDate: Yup.string().nullable(),
    Details: Yup.string().nullable(),
    CategoryID: Yup.number().nullable(),
    Status:  Yup.number()
    .typeError("Status is required")
    .required("Status is required"),
  });

  const validateField = async (fieldName, value) => {
    try {
      await validationSchema.validateAt(fieldName, { [fieldName]: value });
      setErrors((prev) => ({ ...prev, [fieldName]: "" }));
      return true;
    } catch (err) {
      setErrors((prev) => ({ ...prev, [fieldName]: err.message }));
      return false;
    }
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    await validateField(name, value);
  };

  const handleSelect = async (selectedOption, name) => {
    const value = selectedOption ? selectedOption.value : null;
    setFormData((prev) => ({ ...prev, [name]: value }));
    await validateField(name, value);
  };

  const handleDateChange = (date, name) => {
    const formattedDate = date ? date.toISOString().split("T")[0] : "";
    setFormData((prev) => ({ ...prev, [name]: formattedDate }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Validate entire form
      await validationSchema.validate(formData, { abortEarly: false });

      const response = await PostServiceCaller(
        `${API_URL}projectmanagement/task/my-task/${id}`,
        formData,
        "put"
      );

      if (response?.status === 200) {
        toast.success("Task created successfully!");
        setTimeout(() => {
          navigate("/my-task");
        }, 1000);
      } else {
        throw new Error(response?.data?.message || "Failed to create task");
      }
    } catch (error) {
      console.error("Error creating task:", error);

      if (error.inner) {
        // Yup validation errors
        const newErrors = {};
        error.inner.forEach((err) => {
          newErrors[err.path] = err.message;
        });
        setErrors(newErrors);
      } else {
        toast.error(error.message || "Error creating task");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="Container Support-Padding">
    <form
        // onSubmit={handleSubmit}
      id="formOne"
      className="rounded mt-2 bg-white"
    >
      <div className="mx-1">
        <div className="row">
          <div className="col-md-3 mb-3">
            <label className="form-label">
              Project<span className="text-danger">*</span>
            </label>
            <Select
              name="ProjectID"
              options={projectOptions}
              onChange={(option) => handleSelect(option, "ProjectID")}
              value={projectOptions.find((o) => o.value === formData.ProjectID)}
              className={errors.ProjectID ? "is-invalid" : ""}
            />
            {errors.ProjectID && (
              <div className="invalid-feedback d-block">{errors.ProjectID}</div>
            )}
          </div>

          <div className="col-md-3 mb-3">
            <label className="form-label">Category</label>
            <Select
              name="CategoryID"
              options={categoryOptions}
              onChange={(option) => handleSelect(option, "CategoryID")}
              value={categoryOptions.find(
                (o) => o.value === formData.CategoryID
              )}
            />
          </div>

          <div className="col-md-3 mb-3">
            <label className="form-label">
              Task<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="Name"
              className={`form-control ${errors.Name ? "is-invalid" : ""}`}
              value={formData.Name}
              onChange={handleChange}
            />
            {errors.Name && (
              <div className="invalid-feedback d-block">{errors.Name}</div>
            )}
          </div>

          <div className="col-md-3 mb-3">
            <label className="form-label">Status</label>
            <Select
              name="Status"
              className={` ${errors.Status ? "is-invalid" : ""}`}
              options={newStatusOptions}
              onChange={(option) => handleSelect(option, "Status")}
              value={newStatusOptions.find(
                (o) => o.value === formData.Status
              )}
            /> {errors.Status && (
              <div className="invalid-feedback d-block">{errors.Status}</div>
            )}
          </div>
        </div>

        <div className="row">
          <div className="col-md-3 mb-3">
            <label className="form-label">From Date<span className="text-danger">*</span></label>
            <CustomDatePicker
            className={` ${errors.StartDate ? "is-invalid" : ""}`}
              name="StartDate"
              value={formData.StartDate ?  moment(formData.StartDate).format("DD-MMM-YYYY") : null}
              handleChange={handleChange}
              readOnly
              
            />{errors.StartDate && (
              <div className="invalid-feedback d-block">{errors.StartDate}</div>
            )}
          </div>

          <div className="col-md-3 mb-3">
            <label className="form-label">To Date</label>
            <CustomDatePicker
              name="EndDate"
              // readOnly

              value={
                formData.EndDate
                  ? moment(formData.EndDate).format("DD-MMM-YYYY")
                  : null
              }
              handleChange={handleChange}
              minDate={new Date(formData.StartDate)}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">Description</label>
            <textarea
              name="Details"
              className="form-control"
              value={formData.Details}
              onChange={handleChange}
              rows="3"
            />
          </div>
        </div>

        <div className="row mt-1">
          <div className="col-sm-12 pb-2">
            <div className="d-flex justify-content-end align-items-end m-2  text-right me-2">
              <button
                type="button"
                className="cancel-btn me-2"
                onClick={() => navigate("/my-task")}
              >
                Cancel
              </button>
              <button
                type="submit"
                onClick={handleSubmit}
                className="custom-btn"
                disabled={loading ? true : false}
              >
                {loading ? <FaSpinner class="sm-spinner" /> : "Submit"}
              </button>
            </div>
          </div>
        </div>
        </div>
      </form>
    </div>
  );
};

export default MyTaskEdit;
